// Transient selection stores for Map Builder's room selection and
// Characters mode's roster selection (docs/editor-consolidation/roadmap.md
// Phase 2: "MapRoute's own selectedRoomId... is still plain local useState
// today, as is Characters' roster selector").
//
// These two originally lived in their own file (rather than inline in
// screens-editor.tsx/editor-modes3.tsx) so the now-removed cross-panel
// Inspector could import them without an import cycle through
// screens-editor.tsx's buildPanelRegistry. Each now has only its one owning
// panel as a consumer; kept as transientSelection stores rather than local
// useState purely to avoid unrelated churn, not because anything else reads
// them today.
import { createTransientSelectionStore } from './transientSelection';

/** Set and read by MapRoute (Draw room tool) - which room is open. */
export const useMapSelectedRoomId = createTransientSelectionStore<string | null>(null);

/** Set and read by CharactersRoute's roster list - which character is open.
 * Empty string (not null) matches CharactersRoute's own pre-conversion
 * default exactly - roster ids are never empty, so '' still means "nothing
 * valid selected yet" the same way it always has. */
export const useCharactersSelectedId = createTransientSelectionStore<string>('');
